// Programme catalogue — must stay in sync with backend PROGRAMME_DAYS.
export const PROGRAMME_DAYS = {
  "6 Week Challenge": 42,
  "12 Week": 84,
  "24 Week": 168,
  "Annual": 365,
  // Legacy labels retained so historic records still resolve
  "6 Week": 42,
  "12 week": 84,
  "24 week": 168,
  "4 weeks": 28,
};

export const FE_PROGRAMMES = ["6 Week Challenge"];
export const ALL_SALES_PROGRAMMES = ["12 Week", "24 Week", "Annual"];

/** Given "YYYY-MM-DD" + programme label, return "YYYY-MM-DD" for the end date, or "". */
export function autoEndDate(programme, startDate) {
  if (!programme || !startDate) return "";
  const days = PROGRAMME_DAYS[programme];
  if (!days) return "";
  const d = new Date(startDate);
  if (isNaN(d.getTime())) return "";
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}
